import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import { AppBar, Button, Drawer, IconButton, List, ListItem, ListItemText, Hidden } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const Navbar = () => {
  const [sessionUser, setSessionUser] = useState(null);
  const auth = getAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setSessionUser(user);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [auth]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <List>
        <ListItem button component={Link} to="/">
          <ListItemText primary="Home" />
        </ListItem>
        <ListItem button component={Link} to="/product">
          <ListItemText primary="Product Selection" />
        </ListItem>
        {sessionUser && sessionUser.emailVerified && (
          <ListItem button component={Link} to="/requestsurveys">
            <ListItemText primary="Request Assessments" />
          </ListItem>
        )}
        {sessionUser && sessionUser.emailVerified && (
          <ListItem button component={Link} to="/surveystatus">
            <ListItemText primary="Assessment Status" />
          </ListItem>
        )}
        <ListItem button component={Link} to="/about">
          <ListItemText primary="About" />
        </ListItem>
        <ListItem button component={Link} to="/legal">
          <ListItemText primary="Legal" />
        </ListItem>
        <ListItem button component={Link} to="/contact">
          <ListItemText primary="Contact" />
        </ListItem>
        {sessionUser?.emailVerified && (
          <ListItem button component={Link} to="/account">
            <ListItemText primary="Account" />
          </ListItem>
        )}
        {!sessionUser?.emailVerified && (
          <ListItem button component={Link} to="/signin">
            <ListItemText primary="Sign-in" />
          </ListItem>
        )}
        {!sessionUser?.emailVerified && (
          <ListItem button component={Link} to="/signup">
            <ListItemText primary="Sign-up" />
          </ListItem>
        )}
        {sessionUser?.emailVerified && (
          <ListItem button component={Link} to="/signin" onClick={() => { auth.signOut().then(() => setSessionUser(null)); }}>
            <ListItemText primary="Sign-out" />
          </ListItem>
        )}
      </List>
    </div>
  );

  return (
    <ThemeProvider theme={theme}>
      <AppBar position="static" color="secondary">
        <Toolbar sx={{ flexWrap: 'wrap', justifyContent: 'space-between' }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
            <img src="/favicon.ico" alt="Company Logo" style={{ height: '32px', marginRight: '10px', borderRadius: '6px' }} />
            <Typography variant="h6" color="inherit" noWrap>
              Venture Evaluations
            </Typography>
          </Link>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
};

export default Navbar;
